import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'

class TextBlock extends Component {
  static displayName = 'Card / Image'
  static propTypes = {
    item: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
  }

  render() {
    const { item, theme, newsletterId } = this.props
    return (
      <div className={classNames(theme, 'renderpreview', 'imagetext-preview')}>
        <Choose>
          <When condition={item.image}>
            <Choose>
              <When condition={typeof item.image === 'object'}>
                <img src={item.image.src} alt="" />
              </When>
              <Otherwise>
                <img
                  src={`${process.env.URL}/newsletters/${String(newsletterId).padStart(
                    4,
                    '0',
                  )}/${item.image}`}
                  alt=""
                />
              </Otherwise>
            </Choose>
          </When>
          <Otherwise>
            <div className={theme['empty-image']}>
              <span>Add image in the edit box to the right.</span>
            </div>
          </Otherwise>
        </Choose>
      </div>
    )
  }
}

export default TextBlock



// WEBPACK FOOTER //
// ./ui/Blocks/Image.js